import {
  Box,
  Button,
  Checkbox,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { VisibilityOff, Visibility } from "@mui/icons-material";
import React, { useEffect } from "react";
import Input from "../../components/Input";
import { STORAGE_KEYS } from "../../constants/storagekeys";
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
  showError,
  showToast,
} from "../../helpers";
import { isValidInput } from "../../utils/validations";
import { usePostLogInMutation } from "../../services/auth";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useAppDispatch } from "../../hooks/store";
import { setCredentials } from "../../reducers/authSlice";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = React.useState(false);
  const dispatch = useAppDispatch();
  const [loginMutation, { isLoading }] = usePostLogInMutation();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      remember: false,
    },
    validationSchema: Yup.object({
      remember: Yup.boolean(),
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Please enter a valid email address"
        ),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: async (values: any) => {
      formik.setSubmitting(true);
      const fcmToken = getFromStorage(STORAGE_KEYS.fcmToken);

      const body = {
        email: values.email,
        password: values.password,
        // deviceToken: fcmToken || '123',
        // deviceType: 'WEB',
      };
      console.log(body, "sdfs");
      try {
        const response = await loginMutation(body as any).unwrap();
        if (response?.statusCode === 200) {
          showToast("Logged In Successfully.");
          setToStorage(STORAGE_KEYS.token, response?.data?.token || "");
          setToStorage(STORAGE_KEYS.userData, response?.data || "");
          dispatch(
            setCredentials({
              user: response?.data || null,
              token: response?.data?.token || "",
            })
          );

          if (formik.values.remember) {
            setToStorage(STORAGE_KEYS.credentials, JSON.stringify(body));
          } else {
            removeFromStorage(STORAGE_KEYS.credentials);
          }

          navigate("/dashboard");
        }
      } catch (error: any) {
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  useEffect(() => {
    const data = getFromStorage(STORAGE_KEYS.credentials);
    if (data) {
      const rememberData = JSON.parse(`${data}`);
      formik.setFieldValue("password", rememberData?.password);
      formik.setFieldValue("email", rememberData?.email);
      formik.setFieldValue("remember", true);
    }
  }, []);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: Add login logic here
    navigate("/dashboard");
  };

  return (
    <AuthLayout>
      <div className="authBox">
        <h2>Login</h2>

        <form className="form" onSubmit={formik.handleSubmit}>
          <div className="control_group">
            <label htmlFor="email">Email Address</label>
            <Input
              placeholder="Email"
              name="email"
              id="email"
              isLoginField
              inputProps={{ maxLength: 80 }}
              value={formik.values.email}
              onChange={(val) => {
                if (isValidInput(val.target.value)) {
                  formik.handleChange(val);
                }
              }}
              onBlur={formik.handleBlur}
              helperText={formik.touched.email && formik.errors.email}
            />
          </div>

          <div className="control_group">
            <label htmlFor="password">Password</label>
            <Input
              placeholder="Password"
              password
              id="password"
              name="password"
              isLoginField
              value={formik.values.password}
              onChange={(val) => {
                if (isValidInput(val.target.value)) {
                  formik.handleChange(val);
                }
              }}
              onBlur={formik.handleBlur}
              helperText={formik.touched.password && formik.errors.password}
              eyeIconColor="black"
            />
          </div>

          <div className="control_group w_100 forgot_field">
            <FormControlLabel
              control={<Checkbox />}
              checked={formik.values.remember}
              name="remember"
              onChange={formik.handleChange}
              label="Remember me"
            />
            <Box component="a" onClick={() => navigate("/forgot-password")}>
              Forgot Password?
            </Box>
          </div>

          {/* <div className="control_group d_flex">
            <div className="remember_box">
              <FormControlLabel
                control={<Checkbox />}
                name="remember"
                label="Remember me"
              />
            </div>
            <button
              type="button"
              className="anchor_link"
              onClick={() => navigate("/forgot-password")}
            >
              Forgot Password?
            </button>
          </div> */}

          <div className="form_btn">
            <Button
              type="submit"
              className="btn btn_primary w_100"
              variant="contained"
            >
              Login
            </Button>
          </div>
        </form>
      </div>
    </AuthLayout>
  );
};

export default Login;
